import React from 'react';
import { Link } from 'react-router-dom';
export const CtaSection = () => {
  return <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800 text-white" data-id="element-12">
      <div className="container mx-auto px-4 text-center" data-id="element-13">
        <h2 className="text-3xl font-bold mb-6" data-id="element-14">Ready to Get Started?</h2>
        <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-15">
          Create your account today and access over 200 government services from
          anywhere, anytime.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-16">
          <Link to="/register" className="px-8 py-3 bg-white text-blue-700 font-medium rounded-lg hover:bg-blue-50 transition-colors" data-id="element-17">
            Create Account
          </Link>
          <Link to="/services" className="px-8 py-3 bg-blue-700 text-white font-medium rounded-lg border border-white hover:bg-blue-800 transition-colors" data-id="element-18">
            Explore Services
          </Link>
        </div>
      </div>
    </section>;
};